import get from 'lodash/get';
import {
    hasValue, isNullOrUndefined, isNumber, setHtmlIdAttribute
} from '../../../general/js/general-helpers';
import { getAvailableChoices, getHoleData } from '../../live-player/js/live-player-helpers';
import { shotTrackerConstants } from './shot-tracker-constants';
import { PLAYOFF_ROUND_ID } from '../../../general/js/constants';

export const shouldLoadRouteToHoleClipTag = (routeHolder, clipTag) => {
    return !isNullOrUndefined(routeHolder) &&
        !isNullOrUndefined(clipTag);
};

export const getLivePlayerRouteToHoleConfig = (props) => {
    if (!hasValue(props)) {
        return null;
    }

    return get(props, shotTrackerConstants.scorecardRouteToHoleConfig, null);
};

export const getClipTagParametersFromInitialProps = (props, clipTagContainerDiv = null) => {
    const { scoringPlayer } = props;
    const liveShotViewConfig = getLivePlayerRouteToHoleConfig(props);

    if (!hasValue(scoringPlayer) || !hasValue(liveShotViewConfig)) {
        return formatClipTagParameters();
    }
    const teamNo = parseInt(get(scoringPlayer, 'sitecoreData.teamNo', 0));
    const roundChoices = getAvailableChoices(props);
    const { eventCentreParameters, usePlayerStrokesProperty } = liveShotViewConfig;
    const { round, hole, playerPar } = getHoleData(scoringPlayer, roundChoices, null, usePlayerStrokesProperty);

    const playOffData = {
        isPlayoffMode: isPlayOff(roundChoices),
        playOffView: hasInitialContext(liveShotViewConfig) ? eventCentreParameters.initialContext.playoffView : '',
        groupId: hasValue(eventCentreParameters) ? eventCentreParameters.groupId : '',
        playerTrackerView: getPlayerTrackerView(eventCentreParameters)
    };

    if (!isNumber(playerPar) || playerPar === 0 || !isNumber(teamNo) || teamNo === 0 || !isValidEventCentreParameters(eventCentreParameters)) {
        return formatClipTagParameters();
    }

    return formatClipTagParameters(teamNo, round, hole, eventCentreParameters, clipTagContainerDiv, playOffData);
};

export const formatClipTagParameters = (imgaTeamNo = null, roundId = null, holeId = null, eventCentreParameters = null, domElement = null, playOffData = {}) => {
    var formattedParams = isNumber(imgaTeamNo) && parseInt(imgaTeamNo) !== 0 && isNumber(holeId) && isNumber(roundId) && hasValue(eventCentreParameters) ?
        {
            teamNo: parseInt(imgaTeamNo),
            round: parseInt(roundId),
            hole: parseInt(holeId),
            playOffData: playOffData,
            eventCentreParams: formatEventCentreParameters(eventCentreParameters, domElement)
        } :
        { };

    return addContextData(formattedParams);
};

export const hasInitialContext = (clipTagParameters = {}) => {
    return hasValue(clipTagParameters) &&
           (
            (hasValue(clipTagParameters.eventCentreParams) && hasValue(clipTagParameters.eventCentreParams.initialContext)) ||
            (hasValue(clipTagParameters.eventCentreParameters) && hasValue(clipTagParameters.eventCentreParameters.initialContext))
           )
};

const addContextData = (clipTagParameters = {}) => {
    const { round, hole, teamNo, playOffData } = clipTagParameters;

    if(isPlayOffDataValid(playOffData, round)){
        clipTagParameters = addContextProperty(clipTagParameters, shotTrackerConstants.view, playOffData.playOffView);
        clipTagParameters = addContextProperty(clipTagParameters, shotTrackerConstants.groupId, playOffData.groupId);
        clipTagParameters = addContextProperty(clipTagParameters, shotTrackerConstants.roundNo, round);
    }
    else {
        clipTagParameters = hasValue(playOffData) ? addContextProperty(clipTagParameters, shotTrackerConstants.view, playOffData.playerTrackerView) : clipTagParameters;
        clipTagParameters = addContextProperty(clipTagParameters, shotTrackerConstants.teamNo, teamNo);
        clipTagParameters = addContextProperty(clipTagParameters, shotTrackerConstants.roundNo, round);
        clipTagParameters = addContextProperty(clipTagParameters, shotTrackerConstants.holeNo, hole);
    }

    return clipTagParameters;
};

const addContextProperty = (clipTagParameters = {}, propertyName = '', value = 0) => {
    if (hasInitialContext(clipTagParameters) && hasValue(propertyName) && hasValue(value)) {
        clipTagParameters.eventCentreParams.initialContext[propertyName] = value;
    }

    return clipTagParameters;
};

const isPlayOffDataValid = (playOffData = {}, round = -1) => {
    return hasValue(playOffData) &&
           playOffData.isPlayoffMode &&
           hasValue(round) &&
           round.toString() === PLAYOFF_ROUND_ID.toString() &&
           hasValue(playOffData.playOffView) &&
           hasValue(playOffData.groupId)
}

export const formatEventCentreParameters = (eventCentreParameters = null, domElement = null) => {
    const formattedParams = isValidEventCentreParameters(eventCentreParameters) ?
        {
            operator: eventCentreParameters.operator,
            sport: eventCentreParameters.sport,
            eventId: eventCentreParameters.eventId,
            targetModule: eventCentreParameters.targetModule,
            version: eventCentreParameters.version,
            language: eventCentreParameters.language,
            targetElementSelector: hasValue(domElement) ? domElement : getCurrentTargetElementSelector(eventCentreParameters)
        } :
        { };

    if (!hasValue(formattedParams)) {
        return formattedParams;
    }

    if (hasValue(eventCentreParameters.env)) {
        formattedParams.env = eventCentreParameters.env;
    }

    if (hasValue(eventCentreParameters.initialContext) && hasValue(eventCentreParameters.initialContext.view)) {
        formattedParams.initialContext = {
            view: eventCentreParameters.initialContext.view
        };
    }

    return formattedParams;
};

const getPlayerTrackerView = (eventCentreParameters = {}) => {
    var playerTrackerView = '';

    if(!hasValue(eventCentreParameters) || !hasValue(eventCentreParameters.initialContext)){
        return playerTrackerView;
    }

    return eventCentreParameters.initialContext.view;
}

const getCurrentTargetElementSelector = (eventCentreParameters = null) => {
    if (!hasValue(eventCentreParameters)) {
        return '';
    }

    const { targetElementSelector } = eventCentreParameters;

    if (typeof targetElementSelector === 'string') {
        if (targetElementSelector.includes('#')) {
            return targetElementSelector;
        }

        return `#${targetElementSelector}`;
    }

    return targetElementSelector;
};

export const isValidEventCentreParameters = (eventCentreParameters = null) => {
    return hasValue(eventCentreParameters) &&
           hasValue(eventCentreParameters.operator) &&
           hasValue(eventCentreParameters.sport) &&
           hasValue(eventCentreParameters.eventId) &&
           hasValue(eventCentreParameters.targetModule) &&
           hasValue(eventCentreParameters.version) &&
           hasValue(eventCentreParameters.language) &&
           hasValue(eventCentreParameters.targetElementSelector);
};

export const setClipTagContainerId = (liveShotViewConfig, clipTagContainerDiv) => {
    if (!hasValue(liveShotViewConfig)) return;

    const { eventCentreParameters } = liveShotViewConfig;

    if (!hasValue(eventCentreParameters)) return;

    const { targetElementSelector } = eventCentreParameters;

    setHtmlIdAttribute(clipTagContainerDiv, targetElementSelector);
};

export const getIMGArenaESModuleScriptInnerHTML = (esModuleSourceUrl = '') => {
    if (!hasValue(esModuleSourceUrl)) {
        return '';
    }

    return `import frontRowSeat from '${esModuleSourceUrl}';window.frontRowSeat = frontRowSeat;if(window.frontRowSeatESModuleCallback !== null && window.frontRowSeatESModuleCallback !== undefined) window.frontRowSeatESModuleCallback();`;
};

export const getEventCentreTargetElement = (livePlayerShotViewConfig = {}) => {
    const targetElementSelector = hasValue(livePlayerShotViewConfig) ? get(livePlayerShotViewConfig, 'eventCentreParameters.targetElementSelector', '') : '';
    return hasValue(targetElementSelector) ? document.getElementById(targetElementSelector) : null;
};

export const getEventCentreMessageTopics = () => {
    if (!hasValue(window.frontRowSeat) || !hasValue(window.frontRowSeat.eventCentreUtils)) {
        return {};
    }

    const { frontRowSeat: { eventCentreUtils: { MessageTopics } } } = window;

    return MessageTopics;
};

export const updateEventCentreContext = (data = {}, topic = '', eventCentreInstance = null) => {
    if (isNullOrUndefined(eventCentreInstance) || !hasValue(data) || !hasValue(topic)) {
        return;
    }
    console.log(data);
    eventCentreInstance.emit(topic, data);
};

export const isPlayOff = (roundChoices = []) => {
    var isPlayOffRoundSelected = false;

    if(hasValue(roundChoices)){
        isPlayOffRoundSelected = roundChoices.some((choice) => choice.selected === true && choice.value === PLAYOFF_ROUND_ID.toString());
    }
    
    return isPlayOffRoundSelected;
}
